import React, {
  FC,
} from 'react';
import invert from 'lodash/invert';
import {
  useNavigate,
  useParams,
} from 'react-router-dom';
import NavigationTabs from 'pages/Dashboard/components/NavigationTabs';
import AppointmentTypeSettings from 'views/EMR/Settings/Appointments/AppointmentTypeSettings';
import {
  settingsEventChannel,
} from 'pages/Dashboard/services/eventChannels';
import AddIcon from '@mui/icons-material/Add';
import Button from 'pages/Dashboard/components/Button';
import AppointmentStatusSettings from 'views/EMR/Settings/Appointments/AppointmentStatusSettings';
import PatientSelfServiceSettings from 'views/EMR/Settings/Appointments/PatientSelfServiceSettings';
import SETTINGS_PATHS from 'views/EMR/Settings/paths';

const configs = ['types', 'statuses-and-rooms', 'patient-self-service'] as const;
const configsByIndex = invert(configs);
const tabs = [{
  label: 'Types',
  singularLabel: 'Type',
  key: 'types',
}, {
  label: 'Statuses & Rooms',
  singularLabel: '--',
  key: 'statuses-and-rooms',
}, {
  label: 'Patient Self-Service',
  singularLabel: '--',
  key: 'patient-self-service',
}];

const componentsByConfig: Record<string, FC<any>> = Object.freeze({
  types: AppointmentTypeSettings,
  'statuses-and-rooms': AppointmentStatusSettings,
  'patient-self-service': PatientSelfServiceSettings,
});

export type AppointmentSettingParams = { config: typeof configs[number] };

export default function AppointmentSettings() {
  const { config = 'types' } = useParams<AppointmentSettingParams>();
  const navigate = useNavigate();
  const activeIndex = Number(configsByIndex[config]);

  const Component = componentsByConfig[config];
  return (
    <div className="h-full w-full flex flex-col gap-4 overflow-hidden">
      <div className="flex px-4 w-full justify-between">
        <div className="flex gap-4">
          <NavigationTabs
            classes={{
              root: '!min-h-[unset]',
              tab: '!font-semibold !min-w-[unset] !w-fit',
              active: '!border-blue-500 !text-blue-500',
            }}
            tabs={tabs}
            activeIndex={activeIndex}
            onClick={(index) => {
              navigate(`${SETTINGS_PATHS.APPOINTMENTS}/${configs[index]}`);
            }}
          />
        </div>
        {config === 'types' && (
          <Button
            className="!h-8"
            variant="contained"
            color="primary"
            type="button"
            startIcon={<AddIcon className="!w-4 !h-4" />}
            onClick={() => {
              settingsEventChannel.emit('onCreateAppointmentType', {});
            }}
          >
            Add Type
          </Button>
        )}
      </div>
      <Component />
    </div>
  );
}
